/** Indian mobile → international digits for wa.me (919876543210), or null when it does not look like a mobile number. */
export function waNumber(phone: string | null | undefined): string | null {
  const digits = String(phone || '').replace(/\D/g, '').replace(/^0+/, '')
  const ten = digits.length === 12 && digits.startsWith('91') ? digits.slice(2) : digits
  return /^[6-9]\d{9}$/.test(ten) ? `91${ten}` : null
}

/** Click-to-chat link: opens WhatsApp with the message typed; a person presses Send. No account or API needed. */
export function waLink(phone: string | null | undefined, text: string): string | null {
  const n = waNumber(phone)
  return n ? `https://wa.me/${n}?text=${encodeURIComponent(text)}` : null
}

const inr = (n: number) => `₹${Math.round(n).toLocaleString('en-IN')}`
const dmy = (iso: string) => { const [y, m, d] = iso.split('-'); return `${d}-${m}-${y}` }
const footer = (company: string, whatsapp?: string | null) => `\n\n— ${company}${whatsapp ? `\nWhatsApp / call: ${whatsapp}` : ''}`

export function invoiceMessage(p: { customer: string; invoiceNo: string; date: string; amount: number; balance: number; company: string; whatsapp?: string | null; upiId?: string | null }) {
  const lines = [`Hello ${p.customer},`, `Thank you for your purchase. Your invoice ${p.invoiceNo} dated ${dmy(p.date)} is for ${inr(p.amount)}.`]
  if (p.balance > 0) lines.push(`Balance to pay: ${inr(p.balance)}${p.upiId ? ` (UPI: ${p.upiId})` : ''}.`)
  else lines.push('Paid in full. Thank you!')
  lines.push('The invoice PDF is attached.')
  return lines.join('\n') + footer(p.company, p.whatsapp)
}

export function reminderMessage(p: { store: string; overdue: number; outstanding: number; invoices: Array<{ invoiceNo: string; balance: number; overdueDays: number }>; company: string; whatsapp?: string | null; upiId?: string | null }) {
  const list = p.invoices.slice(0, 8).map((i) => `• ${i.invoiceNo} — ${inr(i.balance)} (${i.overdueDays} day${i.overdueDays === 1 ? '' : 's'} overdue)`).join('\n')
  const more = p.invoices.length > 8 ? `\n…and ${p.invoices.length - 8} more` : ''
  return `Hello ${p.store},\n\nA gentle reminder: ${inr(p.overdue)} is overdue on your account with us.\n${list}${more}\n\nTotal outstanding: ${inr(p.outstanding)}.${p.upiId ? `\nYou can pay by UPI: ${p.upiId}` : ''}\nIf you have already paid, please share the payment details. Thank you.` + footer(p.company, p.whatsapp)
}
